import Keyword from './Keyword';

export default class ObjectKeyword extends Keyword {}
